import { render, staticRenderFns } from "./HorizontalPhotos.vue?vue&type=template&id=4f94f314"
import script from "./HorizontalPhotos.vue?vue&type=script&lang=js"
export * from "./HorizontalPhotos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports